import { useEffect, useRef } from 'react';

import { useTypedSearchParams } from 'react-router-typesafe-routes';
import { useSearchParams } from 'react-router-dom';

import { ModalController } from '../modals';
import { modalRegistry } from '../modals/urlModals/registry';
import { ROUTES, extractModalParams, type ModalNameType } from '../routes';

export const useUrlModals = () => {
  const [{ modal }] = useTypedSearchParams(ROUTES);
  const [searchParams] = useSearchParams();
  const lastProcessedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!modal) {
      lastProcessedRef.current = null;
      return;
    }

    // Build a key from modal + all m_* params for deduplication
    const modalParams = extractModalParams(searchParams);
    const modalKey = `${modal}:${JSON.stringify(modalParams)}`;

    if (modalKey === lastProcessedRef.current) {
      return;
    }

    const registryEntry = modalRegistry[modal as ModalNameType];
    if (!registryEntry) return;

    lastProcessedRef.current = modalKey;

    const props = registryEntry.getProps(modalParams);
    ModalController.show(registryEntry.component, props);
  }, [modal, searchParams]);
};
